/*
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.58
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';
import AqaSource from './AqaSource';
import AqaSourceActivityForPeriod from './AqaSourceActivityForPeriod';

/**
 * The AqaSourceActivityAndSourceForPeriod model module.
 * @module model/AqaSourceActivityAndSourceForPeriod
 * @version v0
 */
export default class AqaSourceActivityAndSourceForPeriod {
  /**
   * Constructs a new <code>AqaSourceActivityAndSourceForPeriod</code>.
   * @alias module:model/AqaSourceActivityAndSourceForPeriod
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>AqaSourceActivityAndSourceForPeriod</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/AqaSourceActivityAndSourceForPeriod} obj Optional instance to populate.
   * @return {module:model/AqaSourceActivityAndSourceForPeriod} The populated <code>AqaSourceActivityAndSourceForPeriod</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new AqaSourceActivityAndSourceForPeriod();
      if (data.hasOwnProperty('source'))
        obj.source = AqaSource.constructFromObject(data['source']);
      if (data.hasOwnProperty('sourceActivity'))
        obj.sourceActivity = AqaSourceActivityForPeriod.constructFromObject(data['sourceActivity']);
    }
    return obj;
  }
}

/**
 * @member {module:model/AqaSource} source
 */
AqaSourceActivityAndSourceForPeriod.prototype.source = undefined;

/**
 * @member {module:model/AqaSourceActivityForPeriod} sourceActivity
 */
AqaSourceActivityAndSourceForPeriod.prototype.sourceActivity = undefined;

